import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { GlobalFilter } from "../../components/table/FilteringTable/GlobalFilter";
import { Table } from "antd";
import { columns } from "./components/utils";
import { fetchAllRates } from "../../../services/RatesService";
import { fetchAllReports } from "../../../services/ReportService";

const ReportManagement = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [allReports, setAllReports] = useState([]);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [showReportModal, setShowReportModal] = useState(false);
  const [viewOrEdit, setViewOrEdit] = useState("none");
  const [selectedReport, setSelectedReport] = useState({});

  useEffect(() => {
    getAllReports();
  }, []);

  const getAllReports = () => {
    fetchAllReports()
      .then((res) => {
        const response = res?.data?.result;
        console.log(response);
        setAllReports(response?.data ?? []);
        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: response?.count,
        }));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const deleteHandler = (id) => {
    try {
      //   deleteTenant(id)
      //     .then((res) => {
      //       getAllRoles();
      //       swal("Success", "Role Deleted successfully", "success");
      //     })
      //     .catch((error) => {
      //       if (error.response.status === 403) {
      //         swal("Not Authorize", "You are not Authorize to Delete role", "error");
      //       }
      //     });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div class="card">
      {loading && <Loader forProcess={true} />}
      <div class="card-header d-sm-flex d-block">
        <div class="me-auto mb-sm-0">
          <h4 class="card-title">Report Management</h4>
        </div>
        <GlobalFilter filter={searchTerm} setFilter={setSearchTerm} />
      </div>

      <div class="card-body">
        <Table
          columns={columns(setViewOrEdit, setShowReportModal, setSelectedReport, tableParams, deleteHandler)}
          rowKey={(record) => record.id}
          dataSource={allReports}
          pagination={tableParams}
          onChange={handleTableChange}
        />
      </div>

      {/* add modal */}
    </div>
  );
};

export default ReportManagement;
